/* eslint-disable */
import React from 'react';
import { getSmoothStepPath, useStore } from '@xyflow/react';
import { getEdgeParams } from '../utils';

function CustomConnectionLine({ fromX, fromY, toX, toY, fromNodeId, toNodeId, connectionLineStyle }) {
  // Fetch nodes from React Flow store
  const fromNode = useStore((store) => store.nodeLookup.get(fromNodeId));
  const toNode = useStore((store) => (toNodeId ? store.nodeLookup.get(toNodeId) : null));

  let sourceX = fromX;
  let sourceY = fromY;
  let targetX = toX;
  let targetY = toY;
  let sourcePosition = 'bottom';
  let targetPosition = 'top';

  // Use getEdgeParams if both nodes are available
  if (fromNode && toNode) {
    const { sx, sy, tx, ty, sourcePos, targetPos } = getEdgeParams(fromNode, toNode);
    sourceX = sx;
    sourceY = sy;
    targetX = tx;
    targetY = ty;
    sourcePosition = sourcePos;
    targetPosition = targetPos;
  }

  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition
  });

  return (
    <g>
      <path
        style={{
          ...connectionLineStyle,
          stroke: connectionLineStyle?.stroke || '#cdcdcd',
          strokeWidth: connectionLineStyle?.strokeWidth || 2,
          fill: 'none'
        }}
        d={edgePath}
      />
      <circle cx={targetX} cy={targetY} fill="#cdcdcd" r={3} stroke="#cdcdcd" strokeWidth={1.5} />
    </g>
  );
}

export default CustomConnectionLine;
